import type { ContactRow } from '@shared/flow/contact-view';
import type { ContactIntelContactFields } from '@shared/flow/contact-intel';

/**
 * Contact Intelligence wire projection (D6, plan
 * `plans/2026-09-22-contact-actions-intelligence-implementation-plan.md`
 * §3b item 3) — lifted verbatim out of `ContactIntelPanel.tsx` (plan 005
 * Wave 0 U1a) so V2's Contact Intelligence card can build the same request
 * body V1 does, off the same already-validated `ContactRow`.
 *
 * A PLAIN OBJECT LITERAL projection off the already-validated `row` prop —
 * no `ContactIntelContactFieldsSchema.parse` here (the row already crossed
 * the trust boundary once, at `GET /api/flow/contacts`).
 */
export function toContactIntelFields(row: ContactRow): ContactIntelContactFields {
  return {
    id: row.id,
    name: row.name,
    title: row.title,
    email: row.email,
    persona: row.persona,
    persona_tier: row.persona_tier,
    contact_stage: row.contact_stage,
    job_level: row.job_level,
    mailing_state: row.mailing_state,
    mailing_country: row.mailing_country,
    fit_score: row.fit_score,
    total_engagement_score: row.total_engagement_score,
    product_engagement_score: row.product_engagement_score,
    signals_engagement_score: row.signals_engagement_score,
    last_workspace_login: row.last_workspace_login,
    last_email_sent: row.last_email_sent,
    gong_in_flow: row.gong_in_flow,
    gong_flow_name: row.gong_flow_name,
    no_longer_at_company: row.no_longer_at_company,
    account_id: row.account_id,
    account_name: row.account_name,
  };
}
